export function resolvePublicPath(checkoutSlug, publicPath) {
  if (!checkoutSlug || !publicPath) return '';
  const suffix = publicPath.startsWith('/') ? publicPath : `/${publicPath}`;
  return `/lp/${encodeURIComponent(checkoutSlug)}${suffix}`;
}

export function collectSiteComponents(site) {
  const comps = [];
  if (site?.pageMenu) comps.push(site.pageMenu);
  for (const sec of site?.sections || []) {
    comps.push(...(sec.components || []));
  }
  return comps;
}

export function siteHasRestaurantPage(site) {
  if ((site?.sections || []).some((sec) => sec.designKit === 'jardins')) return true;
  return collectSiteComponents(site).some(
    (c) => c.type === 'restaurantPage' || c.type === 'restaurantSection',
  );
}

export function siteHasClickCollectComponent(site) {
  if (collectSiteComponents(site).some((c) => c.type === 'clickAndCollect')) return true;
  return (
    siteHasRestaurantPage(site) &&
    Array.isArray(site?.clickAndCollect?.items) &&
    site.clickAndCollect.items.length > 0
  );
}

export function siteHasReservationComponent(site) {
  if (collectSiteComponents(site).some((c) => c.type === 'reservation')) return true;
  return siteHasRestaurantPage(site);
}

export function siteHasCommerceAdmin(site) {
  return siteHasClickCollectComponent(site) || siteHasReservationComponent(site);
}

export function buildCommerceAdminTabs(site) {
  const tabs = [{ id: 'overview', label: "Vue d'ensemble", icon: 'LayoutDashboard' }];
  if (siteHasClickCollectComponent(site)) {
    tabs.push(
      { id: 'menu', label: 'Menu & stock', icon: 'UtensilsCrossed' },
      { id: 'orders', label: 'Click & Collect', icon: 'Receipt' },
    );
  }
  if (siteHasReservationComponent(site)) {
    tabs.push(
      { id: 'reservation', label: 'Paramètres', icon: 'Settings2' },
      { id: 'res-requests', label: 'Réservations', icon: 'CalendarCheck' },
    );
  }
  tabs.push({ id: 'hubup-alerts', label: 'Alertes HubUP', icon: 'Bell' });
  return tabs;
}

/** @deprecated alias */
export function siteHasCommerceModule(site) {
  if (siteHasCommerceAdmin(site)) return true;
  const m = site?.modules || {};
  return Boolean(m.clickAndCollect || m.reservation);
}

export function getCommerceCapabilities(site) {
  const legacy = site?.modules || {};
  const hasCcData =
    Array.isArray(site?.clickAndCollect?.items) && site.clickAndCollect.items.length > 0;
  return {
    clickAndCollect:
      siteHasClickCollectComponent(site) || legacy.clickAndCollect === true || hasCcData,
    reservation:
      siteHasReservationComponent(site) || legacy.reservation === true,
  };
}

export function computeClickCollectStats(orders) {
  const list = Array.isArray(orders) ? orders : [];
  const active = list.filter((o) => o?.status !== 'cancelled');
  const completed = active.filter(
    (o) => o?.status === 'completed' || o?.status === 'fulfilled',
  );
  const salesCount = completed.length;
  const revenueTtc = completed.reduce(
    (sum, o) => sum + (Number(o?.totalTtc) || 0),
    0,
  );
  const pendingCount = active.filter((o) => o?.status === 'pending').length;
  const inProgressCount = active.filter(
    (o) => o?.status === 'confirmed' || o?.status === 'ready',
  ).length;
  return { salesCount, revenueTtc, pendingCount, inProgressCount };
}

export function formatPriceTtc(value) {
  const n = Number(value) || 0;
  return n.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });
}

export function newClickCollectItem(overrides = {}) {
  return {
    id: `cc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`,
    title: '',
    description: '',
    category: '',
    priceHt: 0,
    vatRate: 10,
    priceTtc: 0,
    imageUrls: [],
    quantityAvailable: 0,
    active: true,
    ...overrides,
  };
}

/** Regroupe les articles par catégorie (ordre d’apparition). */
export function groupItemsByCategoryName(items) {
  const map = new Map();
  const order = [];
  for (const item of items || []) {
    const cat = String(item.category || '').trim() || 'Sans catégorie';
    if (!map.has(cat)) {
      map.set(cat, []);
      order.push(cat);
    }
    map.get(cat).push(item);
  }
  return order.map((name) => ({ name, items: map.get(name) || [] }));
}

export function isCommerceButtonType(type) {
  return type === 'clickAndCollect' || type === 'reservation';
}
